<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:33:39
 * @LastEditTime: 2021-01-20 11:34:25
 * @LastEditors: daikeyi
 -->
<template>
    <div id="page_Container" :class='{backgroundBgWhite:!timeShow}'>
        <div v-if='timeShow' id="membercenter">
            <div id="main-container">
                <div class='centerHeader'>
                    <div class="header-wrapper">
                        <div class="headPortrait" v-on:click="openInfo" v-bind:style="{backgroundImage:'url(' + headerImg + ')'}"></div>
                        <div class="bingling"></div>
                        <div class="nickName"><span>{{Nickname}}</span></div>
                    </div>
                    <!-- 分销开通 -->
                    <div class="header-distribution">
                        <p class="txt">开通分销账户，推广分销得盈利</p>
                        <div class="btn-distribution" @click="toPage" v-show="isOpenRetailStore === 1">{{distribution}}</div>
                        <div class="btn-distribution" v-show="isOpenRetailStore === 2">敬请期待</div>
                    </div>
                    <!-- 会员开通 -->
                    <div class="header-member">
                        <div class="img"></div>
                        <div class="txt">
                            <div class="title">超级会员</div>
                            <div class="value">会员推广专享特权·专属商品·优选折上折</div>
                        </div>
                    </div>
                    <!-- <van-row class='infoStyleClass'>
                        <van-col span="8" class='infoOne' v-for='item in indexTypeData' :key='item.type'>
                            <div @click='open(item.type)'>
                                <p>{{defaultData[item.quantity] ? defaultData[item.quantity] : 0}}</p>
                                <p>{{item.name}}</p>
                            </div>
                        </van-col>
                    </van-row> -->
                </div>
                <div class='myOrder'>
                    <van-cell-group>
                        <van-cell title="" is-link value="全部订单" @click='orderClick("")'>
                            <template slot="title">
                                <span>我的订单</span>
                            </template>
                        </van-cell>
                    </van-cell-group>
                    <div class='myOrderlist'>
                        <van-row type="flex" justify="center" class='OrderListClass'>
                            <van-col span="5" v-for='item in orderTypeData' :key='item.type'>
                                <div @click='orderClick(item.type)'>
                                    <van-tabbar-item :info="defaultData[item.quantity] ? defaultData[item.quantity] : null">
                                        <span>{{item.name}}</span>
                                        <img slot="icon" :src="item.orderImg">
                                    </van-tabbar-item>
                                </div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
                <div class="list-wrapper">
                    <van-cell-group>
                        <van-cell title="我的分销" is-link value="" @click='distributionClick' v-show="isDistribution === 3 && isOpenRetailStore === 1">
                            <div slot="icon" class="img">
                                <img :src="iconImg.connections" alt=""  style="width: 15px;height: 14px">
                            </div>
                        </van-cell>
                        <van-cell title="我的收藏" is-link :value="defaultData.accountCollectionQuantity + '个'" @click='collectClick'>
                            <div slot="icon" class="img">
                                <img :src="iconImg.collection" alt=""  style="width: 14px;height: 14px">
                            </div>
                        </van-cell>
                        <van-cell title="我的优惠" is-link :value="defaultData.accountCardQuantity+'张'" @click='dicountClick'>
                            <div slot="icon" class="img">
                                <img :src="iconImg.discount" alt=""  style="width: 14px;height: 14px">
                            </div>
                        </van-cell>
                        <van-cell title="地址管理" is-link value="" @click='addressClick'>
                            <div slot="icon" class="img">
                                <img :src="iconImg.map" alt=""  style="width: 12px;height: 16px">
                            </div>
                        </van-cell>
                        <van-cell title="我的积分" is-link :value="defaultData.accountPointQuantity" @click='pointClick'>
                            <div slot="icon" class="img">
                                <img :src="iconImg.brand" alt=""  style="width: 14px;height: 16px">
                            </div>
                        </van-cell>
                        <van-cell title="发票管理" is-link :value="`${defaultData.invoiceQuantity || 0}张`" @click='invoiceClick'>
                            <div slot="icon" class="img">
                                <img :src="iconImg.print" alt="" style="width: 14px;height: 16px">
                            </div>
                        </van-cell>
                        <van-cell title="我的余额" is-link value="¥0" @click='balanceClick'>
                            <div slot="icon" class="img">
                                <img :src="iconImg.dollar" alt=""  style="width: 8px;height: 14px">
                            </div>
                        </van-cell>
                    </van-cell-group>
                </div>
                <!-- <div class='loveBg' v-if='bgShow'>
                    <img :src="loveImg" alt="">
                </div> -->
                <div class='bottomText'>
                    <div class="copyright">© 2019-{{ new Date().getFullYear() }} <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备17054838号</a></div>
                    <span>易联云商城定制版-易联云提供技术支持</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '../utils/base/utils';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            iconImg: {
                connections: require('@/assets/img/myCenter/connections@3x.png'),
                collection: require('@/assets/img/myCenter/collection@3x.png'),
                discount: require('@/assets/img/myCenter/discount@3x.png'),
                brand: require('@/assets/img/myCenter/brand@3x.png'),
                print: require('@/assets/img/myCenter/print@3x.png'),
                dollar: require('@/assets/img/myCenter/dollar@3x.png'),
                map: require('@/assets/img/myCenter/map@3x.png')
            },
            isOpenRetailStore: '2',
            isDistribution: '',
            isDistributionData: {},
            headerImg: require('../assets/img/myCenter/defaultImg.png'),
            loveImg: require('../assets/img/myCenter/loveshop.png'),
            popShow: false,
            Nickname: '',
            defaultData: {},
            orderTypeData: [
                {
                    type: '10',
                    quantity: 'unpaidQuantity',
                    name: '待付款',
                    orderImg: require('../assets/img/myCenter/orderImg1.png')
                },
                {
                    type: '20',
                    quantity: 'toDeliveredQuantity',
                    name: '待发货',
                    orderImg: require('../assets/img/myCenter/orderImg2.png')
                },
                {
                    type: '40',
                    quantity: 'pendingReceiptQuantity',
                    name: '待收货',
                    orderImg: require('../assets/img/myCenter/orderImg3.png')
                },
                {
                    type: '50',
                    quantity: 'commentQuantity',
                    name: '待评价',
                    orderImg: require('../assets/img/myCenter/orderImg4.png')
                },
                {
                    type: '90',
                    quantity: 'returnedQuantity',
                    name: '退货/售后',
                    orderImg: require('../assets/img/myCenter/orderImg5.png')
                }
            ],
            bgShow: true,
            timeShow: false,
            active: 0
        };
    },
    props: {},
    esvReady() {
        this.getMerchantInfo();
    },
    esvShow() {
        document.title = '我的';
        this.queryMemberAccount();
        this.ESVStorage.putSavedValue('cTabIndex', 3);
        const htmlWidth =
            document.documentElement.clientWidth || document.body.clientWidth;
        // 针对5s做出的适配
        htmlWidth === 320 ? (this.bgShow = false) : (this.bgShow = true);
        this.queryMemberAccountOpenFlag();
    },
    methods: {
        openInfo() {
            this.queryMemberAccountDetail();
        },
        getMerchantInfo() {
            const ths = this;
            const params = {

            };
            ths.$doRequest({
                url: '/merchant/getMerchantInfo',
                params: params,
                before: function () {
                    ths.loading = toastLoading();
                },
                complete: function () {
                    clearToastLoading(ths.loading);
                }
            },
            function (data) {
                ths.isOpenRetailStore = data.result.isOpenRetailStore;
            });
        },
        // 请求详情存入local
        queryMemberAccountDetail() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryMemberAccountDetail',
                    params: { merchantInfo: JSON.stringify(this.merchantInfoSwitch) },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.ESVStorage.putSavedValue(
                        'accountDetail',
                        data.result
                    );
                    ths.esvOpenPage('OPPersonalInformation');
                }
            );
        },
        // 是否是分销账户
        queryMemberAccountOpenFlag() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryMemberAccountOpenFlag',
                    params: {},
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    console.log(data.result);
                    ths.isDistributionData = data.result;
                    ths.isDistribution = data.result.accountReviewStatus;
                    ths.ESVStorage.putSavedValue('isDistribution', ths.isDistribution === 3);
                }
            );
        },
        toPage() {
            if (this.isDistribution === 1) {
                Toast('正在审核中...');
            } else {
                this.esvOpenPage({ name: 'OPPublicityPage', params: { isDistribution: this.isDistribution === 3 } });
            }
        },
        distributionClick() {
            this.esvOpenPage('OPDistributionPage');
        },
        dicountClick() {
            this.esvOpenPage('OPCoupon');
        },
        collectClick() {
            this.esvOpenPage('OPCollectionList');
        },
        pointClick() {
            // this.esvOpenPage('OPPayorder');
            this.esvOpenPage('OPIntegral');
        },
        invoiceClick() {
            this.esvOpenPage('OPInvoiceList');
            // Toast('开发中，敬请期待！');
        },
        balanceClick() {
            Toast('开发中，敬请期待！');
        },
        // 初始化
        queryMemberAccount() {
            const ths = this;
            ths.$doRequest(
                {
                    url: '/account/queryMemberAccount',
                    params: {

                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        // ths.loading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                (data) => {
                    ths.defaultData = data.result;

                    if (ths.defaultData.accountAvatar) {
                        ths.headerImg = ths.defaultData.accountAvatar;
                    }
                    ths.defaultData.accountNickName
                        ? (ths.Nickname = ths.defaultData.accountNickName)
                        : (ths.Nickname = '设置昵称');
                    this.$nextTick(() => { ths.timeShow = true; });
                }
            );
        },
        //
        openAccoutInfo() {
            this.esvOpenPage('OPPersonalInformation');
        },
        addressClick() {
            this.esvOpenPage('OPAddressManage');
        },
        orderClick(type) {
            this.ESVStorage.putSavedValue(
                'status',
                type
            );
            if (type === '90') {
                this.esvOpenPage('OPAfterSalesList');
            } else {
                // this.ESVStorage.putSavedValue(
                //     'status',
                //     type
                // );
                this.esvOpenPage({ name: 'OPMyOrder' });
            }
        },
        open(type) {
            if (type === 1) {
                this.esvOpenPage('OPCollectionList');
            } else if (type === 2) {
                this.esvOpenPage('OPCoupon');
            } else {
                this.esvOpenPage('OPIntegral');
            }
        },
        integral() {
            this.esvOpenPage('OPEvaluate');
        }
    },
    computed: {
        ...mapGetters(['merchantInfoSwitch']),
        distribution() {
            return this.isDistribution === 1 ? '待审核' : this.isDistribution === 3 ? '立即邀请' : '开通分销';
        }
    },
    destroyed() {
    }
};
</script>
<style lang="scss" scoped>
#page_Container {
    // overflow-y: auto;
    #main-container {
        overflow-y: auto;
        overflow-x: hidden;
    }
}
#membercenter {
    height: 100%;
}
.backgroundBgWhite {
    background: white;
}
.centerHeader {
    position: relative;
    background: url(../assets/img/myCenter/headerBackground.png) no-repeat
        center center;
    height: 180px;
    background-size: cover;
    padding: 0 12px;
    // 头像
    .header-wrapper {
        height: 60px;
        padding: 10px 0;
        display: flex;
        .headPortrait {
            border: 1px solid #fff;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-size: cover;
            background-position: center;
        }
        .bingling{
            width:9px;
            height:10px;
            background: url('../assets/img/myCenter/zsw.png') left center no-repeat;
            background-size: cover;
            background-position: center;
        }
        .nickName {
            padding-left: 10px;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 40px;
            text-align: left;
        }
    }
    // 分销
    .header-distribution {
        height: 30px;
        background-image: linear-gradient(90deg, #E2BB91 0%, #C3865B 100%);
        border-radius: 2px;
        padding: 3px 12px;
        display: flex;
        line-height: 24px;
        justify-content: space-between;
        .txt {
            color: #57391D;
        }
        .btn-distribution {
            background-image: linear-gradient(90deg, #FFDFC9 0%, #FBC29F 100%);
            border-radius: 15px;
            height: 24px;
            line-height: 24px;
            padding: 0 10px;
        }
    }
    // 会员
    .header-member {
        position: absolute;
        margin-top: 10px;
        width: calc(100% - 24px);
        background: url('../assets/img/myCenter/headerBg@3x.png') no-repeat center center;
        background-size: cover;
        border-radius: 6px;
        height: 103px;
        display: flex;
        padding: 20px;
        // background-color: #000;
        .img {
            align-self: center;
            background: url('../assets/img/myCenter/member-crown@3x.png') no-repeat center center;
            background-size: cover;
            width: 29px;
            height: 25px;
        }
        .txt {
            align-self: center;
            padding: 10px;
            color: #DCB286;
            .value {
                font-size: 12px;
            }
            .title {
                font-size: 18px;
            }
        }
    }
    .van-hairline--top-bottom::after {
        border-width: 0;
    }
    .van-cell-group {
        background: 0;
        .van-cell {
            background: 0;
            .van-cell__value {
                font-size: 12px!important;
                span {
                    color: white !important;
                }
            }
        }
    }
    .infoStyleClass {
        color: white;
        text-align: center;
        font-size: 14px;
        margin-top: 16px;
        .infoOne {
            padding: 10px;
        }
    }
}
.myOrder {
    margin-top: 37px;
    background: #fff;
    .myOrderlist {
        padding: 16px 0;
    }
    .OrderListClass {
        text-align: center;
        font-size: 14px;
        letter-spacing: 1px;
        img {
            width: 22px;
            height: 22px;
            margin-bottom: 5px;
        }
        .van-tabbar-item__text {
            margin-top: 10px;
            span {
                font-size: 12px;
            }
        }
    }
}
.list-wrapper {
    margin-top: 12px;
    .img {
        width: 15px;
        height: 16px;
        margin-right: 8px;
        img {
            display: block;
            margin: 0 auto;
            max-height: 16px;
            max-width: 15px;
        }
    }
}

.loveBg {
    width: 100%;
    text-align: center;
    position: fixed;
    bottom: 60px;
    img {
        width: 108px;
    }
}

.bottomText {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #CCCCCC;
    text-align: center;
    padding: 12px 15px;
    font-size: 10px;

    .copyright {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        a {
            color: inherit;
        }
    }
}
.perSonClass {
    width: 100%;
    height: 100%;
}
.icon-title {
    margin-left: 5px!important;
}
</style>
